import { ValidatorFn, ValidationErrors, FormArray, AbstractControl } from '@angular/forms';
import { setError } from './setError';

export function PickerValidator(array: FormArray, meta: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (meta.mandatory) {
            const error = array?.controls?.length ? null : { picker: true };
            setError(control, error, 'picker');

            return error;
        }

        if (meta.min) {
            const error = array?.controls?.length >= meta.min ? null : { picker_min: true };
            setError(control, error, 'picker_min');

            return error;
        }

        if (meta.max) {
            const error = array?.controls?.length <= meta.max ? null : { picker_max: true };
            setError(control, error, 'picker_max');

            return error;
        }

        return null;
    };
}
